(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('RequiredDocumentDetailController', RequiredDocumentDetailController);

    RequiredDocumentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RequiredDocument', 'Shipment', 'Keyword'];

    function RequiredDocumentDetailController($scope, $rootScope, $stateParams, previousState, entity, RequiredDocument, Shipment, Keyword) {
        var vm = this;

        vm.requiredDocument = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ccsTrApp:requiredDocumentUpdate', function(event, result) {
            vm.requiredDocument = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
